import React from "react";
import { Button, Modal } from "react-bootstrap";
import { injectIntl } from "react-intl";
import { useDispatch } from "react-redux";
import * as actionsPosts from "../../../../redux/actions/posts";

function DeletePostDialog({ show, onHide, intl, row, activeTab }) {
  const dispatch = useDispatch();

  const onDelete = () => {
    dispatch(actionsPosts.deletePostById(row.id));
    onHide();
  };
  return (
    <>
      <Modal size="lg" show={show} onHide={onHide}>
        <Modal.Header>
          <div>
            {activeTab === 'posts'
              ? "Do you want to delete this post?"
              : "Do you want to delete this draf post?"}
          </div>
        </Modal.Header>
        <Modal.Body>
          <div className="d-flex justify-content-end">
            <div className="mr-2">
              <Button onClick={() => onHide()}>Cancel</Button>
            </div>
            <div>
              <Button onClick={() => onDelete()}>Yes, delete it</Button>
            </div>
          </div>
        </Modal.Body>
      </Modal>
    </>
  );
}

export default injectIntl(DeletePostDialog);
